import React from "react";
import HeaderComponent from "src/components/header/header.component";
import ShopContent from "src/components/shop-content/shop-content.component";
import { ShopProvider } from "src/store";
import { useTranslation } from "react-i18next";
import { headerWithoutTableHeight } from "src/statics/header";

export default function BuildingsPage() {
  const [t] = useTranslation();
  return (
    <ShopProvider>
      <HeaderComponent
        title="CleanTag Shop"
        subtitle={t('order the CleanTags for check-in and out')}
        headerHeight={headerWithoutTableHeight}
        displayMenu={true}
      />
      <ShopContent />
    </ShopProvider>
  );
}
